import React, { useState, useEffect } from "react";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import MenuCard from "./MenuCard";
import { Container } from "react-bootstrap";
import { AnimatePresence } from "framer-motion";
import MenuTable from "./MenuTable";
import configServ from "../../services/config"; // Replace with your actual service
import toast from "react-hot-toast";

const MenuPage = () => {
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [menuList, setMenuList] = useState([]);
  const [loading, setLoading] = useState(true);

  const handlePopup = () => {
    setIsCreate(!isCreate); // Toggles the visibility of the MenuCard
    setIsEdit(false);
  };

  const handleEditData = (data) => {
    setIsEdit(true);
    setIsCreate(true);
    setEditData(data);
  };

  const fetchMenuList = async () => {
    setLoading(true);
    try {
      const res = await configServ.menuList();
      if (res.status === 200 && Array.isArray(res.data)) {
        setMenuList(res.data || []);
      } else {
        setMenuList([]);
        toast.error("Failed to fetch menu list.");
      }
    } catch (e) {
      toast.error("An error occurred!");
      console.log(e);
      setMenuList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMenuList();
  }, []);

  const [permissionsList, setPermissionsList] = useState([]);

  useEffect(() => {
    // Fetch permissions grouped by PageAccessControl
    const fetchPermissions = async () => {
      try {
        const res = await configServ.getPermissionsGroupedByCategory();
        if (res.status === 200 && res.data) {
          const transformedData = Object.entries(res.data).map(
            ([key, value]) => ({
              PageAccessControl: key,
              permissions: value,
            })
          );
          setPermissionsList(transformedData);
        } else {
          setPermissionsList([]);
        }
      } catch (e) {
        console.log(e);
        setPermissionsList([]);
      }
    };
    fetchPermissions();
  }, []);

  return (
    <Container>
      {/* Header */}
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Menu"}
        handlePopup={handlePopup}
        create={isCreate}
        isEdit={isEdit}
        setEditData={setEditData}
      />

      {/* Animated Card */}
      <AnimatePresence>
        {isCreate && (
          <MenuCard
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            editData={editData}
            // clear={clear}
            isCreate={isCreate} // State passed as a prop
            setIsCreate={setIsCreate} // Function passed as a prop
            fetchMenuList={fetchMenuList} // Pass fetch function
            permissionsList={permissionsList}
          />
        )}
      </AnimatePresence>
      <MenuTable
        handleEditData={handleEditData}
        menuList={menuList} // Pass the menuList state
        loading={loading} // Pass the loading state
        fetchMenuList={fetchMenuList} // Pass fetch function

      />
    </Container>
  );
};

export default MenuPage;
